<!-- 定制我的旅程 -->
<template>
  <div class="frame">
    <div class="plan-banner">
      <div class="plan-banner-bg"></div>
    </div>

    <div class="steps-bar">
      <div class="steps-inner">
        <div class="steps-list">
          <template v-for="(step, index) in steps">
            <div class="step-item" :key="'step-' + index">
              <div class="step-icon-wrap">
                <img
                  :src="stepRounds[index]"
                  class="step-icon"
                  :alt="step.title"
                />
              </div>
              <p class="step-label">{{ step.title }}</p>
            </div>
            <i
              v-if="index < steps.length - 1"
              :key="'arrow-' + index"
              class="el-icon-arrow-right step-arrow"
              aria-hidden="true"
            ></i>
          </template>
        </div>
        <div class="steps-divider"></div>
        <button type="button" class="steps-cta" @click="openContactModal">
          {{ $t("planTrip.cta") }}
        </button>
      </div>
    </div>

    <div class="services-section">
      <h2 class="services-title">{{ $t("planTrip.servicesTitle") }}</h2>
      <div class="services-grid">
        <div
          v-for="(item, index) in services"
          :key="index"
          class="service-card"
        >
          <img
            :src="serviceIcons[index]"
            class="service-icon"
            :alt="item.title"
          />
          <h3 class="service-title">{{ item.title }}</h3>
          <p class="service-desc">{{ item.desc }}</p>
        </div>
      </div>
    </div>

    <ContactFormModal :visible.sync="contactFormVisible" />
  </div>
</template>

<script>
import ContactFormModal from "@/components/ContactFormModal.vue";

const STEP_ROUNDS = [
  require("@/assets/trip/round1.png"),
  require("@/assets/trip/round2.png"),
  require("@/assets/trip/round3.png"),
  require("@/assets/trip/round4.png"),
];

const SERVICE_ICONS = [
  require("@/assets/trip/icon1.png"),
  require("@/assets/trip/icon2.png"),
  require("@/assets/trip/icon3.png"),
  require("@/assets/trip/icon4.png"),
];

export default {
  components: { ContactFormModal },
  data() {
    return {
      stepRounds: STEP_ROUNDS,
      serviceIcons: SERVICE_ICONS,
      contactFormVisible: false,
    };
  },
  computed: {
    steps() {
      return this.$t("planTrip.steps");
    },
    services() {
      return this.$t("planTrip.services");
    },
  },
  methods: {
    openContactModal() {
      this.contactFormVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  background-color: #f6fbff;
  padding-bottom: 80px;
}

.plan-banner {
  position: relative;
  width: 100%;
  height: 420px;
  overflow: hidden;
}

.plan-banner-bg {
  width: 100%;
  height: 100%;
  background-image: url("../assets/trip/bg.jpg");
  background-size: cover;
  background-position: center;
}

.steps-bar {
  position: relative;
  z-index: 2;
  margin-top: -36px;
  padding: 0 24px;
  box-sizing: border-box;
}

.steps-inner {
  max-width: 1500px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 28px 32px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
}

.steps-list {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 0;
}

.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.step-icon-wrap {
  width: 72px;
  height: 72px;
  margin-bottom: 10px;
}

.step-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.step-label {
  margin: 0;
  font-size: 14px;
  color: #333;
  text-align: center;
  white-space: nowrap;
}

.step-arrow {
  flex-shrink: 0;
  font-size: 18px;
  color: #c5d0dc;
  margin: 0 4px;
  margin-bottom: 28px;
}

.steps-divider {
  flex-shrink: 0;
  width: 1px;
  height: 72px;
  background: #e8e8e8;
}

.steps-cta {
  flex-shrink: 0;
  min-width: 140px;
  padding: 14px 36px;
  border: none;
  border-radius: 28px;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  background: linear-gradient(90deg, #ffc04d 0%, #ff8c00 48%, #f07800 100%);
  box-shadow: 0 4px 16px rgba(240, 120, 0, 0.35);
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.92;
  }
}

.services-section {
  max-width: 1200px;
  margin: 56px auto 0;
  padding: 0 40px;
  box-sizing: border-box;
}

.services-title {
  margin: 0 0 36px;
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1a;
  text-align: center;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.service-card {
  padding: 28px 22px;
  background: #fff;
  border-radius: 10px;
  border: 1px solid #e8eef5;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.2s, transform 0.2s;

  &:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
    transform: translateY(-2px);
  }
}

.service-icon {
  width: 80px;
  height: 80px;
  object-fit: contain;
  margin-bottom: 20px;
}

.service-title {
  margin: 0 0 12px;
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
}

.service-desc {
  margin: 0;
  font-size: 14px;
  line-height: 1.7;
  color: #666;
}

@media (max-width: 992px) {
  .plan-banner {
    height: 320px;
  }

  .steps-inner {
    flex-direction: column;
    padding: 24px 20px;
  }

  .steps-list {
    flex-wrap: wrap;
    gap: 16px 8px;
  }

  .step-arrow {
    display: none;
  }

  .step-item {
    flex: 0 0 calc(50% - 12px);
  }

  .steps-divider {
    display: none;
  }

  .steps-cta {
    width: 100%;
  }

  .services-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .services-grid {
    grid-template-columns: 1fr;
  }

  .step-label {
    font-size: 13px;
    white-space: normal;
  }
}
</style>
